class CartDrawerAnnouncements extends HTMLElement {
  constructor() {
    super();
    
    this.slider = this.querySelector('.cart-drawer-announcements__slider');
    this.slides = this.querySelectorAll('.cart-drawer-announcements__slide');
    this.prevButton = this.querySelector('.cart-drawer-announcements__arrow--prev');
    this.nextButton = this.querySelector('.cart-drawer-announcements__arrow--next');
    
    this.currentIndex = 0;
    this.autoplayInterval = null;
    
    if (this.slides.length > 1) {
      this.init();
    }
  }
  
  init() {
    this.prevButton?.addEventListener('click', () => this.prev());
    this.nextButton?.addEventListener('click', () => this.next());
    
    this.startAutoplay();
    
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
  }
  
  goToSlide(index) {
    this.currentIndex = index;
    if (this.currentIndex < 0) {
      this.currentIndex = this.slides.length - 1;
    } else if (this.currentIndex >= this.slides.length) {
      this.currentIndex = 0;
    }
    
    const offset = -100 * this.currentIndex;
    this.slider.style.transform = `translateX(${offset}%)`;
  }
  
  next() {
    this.goToSlide(this.currentIndex + 1);
  }
  
  prev() {
    this.goToSlide(this.currentIndex - 1);
  }
  
  startAutoplay() {
    if (this.slides.length <= 1) return;
    
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      this.next();
    }, 4000);
  }
  
  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
  
  disconnectedCallback() {
    this.stopAutoplay();
  }
}

customElements.define('cart-drawer-announcements', CartDrawerAnnouncements);

